import Swiper from 'swiper/bundle';

const heroSlider = document.querySelector(`.js--hero-slider`);

if(heroSlider){
  const heroSliderPagination = heroSlider.querySelector(`.swiper-pagination`);

  const heroSwiper = new Swiper(heroSlider, {
    effect: "fade",
    loop: true,
    speed: 750,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: heroSliderPagination,
      clickable: true,
    }
  });
}